import { Fragment } from 'react'
import { fbt } from 'fbtee'
import type { SearchArtist } from '@shared/searchIndex'

/**
 * A named collab's members ("Members: Boys Noize, Skrillex"), and the collabs
 * an artist also performs as ("Also performs as Dog Blood"), each linking to
 * that artist's page. Renders nothing when the artist has neither.
 */
export function ArtistRelations({
  members,
  collabs,
  onSelect,
}: {
  members: SearchArtist[]
  collabs: SearchArtist[]
  onSelect: (artistId: string) => void
}) {
  if (members.length === 0 && collabs.length === 0) return null

  const links = (list: SearchArtist[]) => list.map((a, i) => (
    <Fragment key={a.id}>
      {i > 0 && ', '}
      <button type="button" className="cursor-pointer font-medium text-foreground hover:underline" onClick={() => onSelect(a.id)}>
        {a.name}
      </button>
    </Fragment>
  ))

  return (
    <div className="space-y-1 text-sm text-muted-foreground" data-testid="artist-relations">
      {members.length > 0 && (
        <p>
          {fbt('Members:', 'Label before the list of artists who make up a named collaboration (e.g. Dog Blood: Boys Noize, Skrillex) on its artist page')}{' '}
          {links(members)}
        </p>
      )}
      {collabs.length > 0 && (
        <p>
          {fbt('Also performs as', 'Label before the named collaborations an artist is a member of, on the artist page (e.g. "Also performs as Dog Blood")')}{' '}
          {links(collabs)}
        </p>
      )}
    </div>
  )
}
